import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'wsd-age-group-total',
  templateUrl: './age-group-total.component.html',
  styleUrls: ['./age-group-total.component.css']
})
export class AgeGroupTotalComponent {

  @Input()
  collection: Array<any>;

  constructor() { }

  totalByCriteria(collection, criteria) {
    if (!collection) {
      return 0;
    }

    return collection.reduce((result, entry) => {
      return result + (entry[criteria] || 0);
    }, 0);
  }
}
